import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../../../ReactComponent';
import { Typography } from '@mui/material';
import BloqueioBaixa from './BloqueioBaixa';
import Transcendencia from './Transcendencia';
import PublicacaoAcordao from './PublicacaoAcordao';
import { red } from '@mui/material/colors';
import PresidenteSignatario from './PresidenteSignatario';

class RodapePainelDecisao extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            qtdPartesAutoras: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get qtdPartesAutoras() {
        if (
            this.registro?.detalhes?.quantidadePartesAutoras &&
            Number.isFinite(this.registro.detalhes.quantidadePartesAutoras)
        ) {
            return Number.parseInt(this.registro.detalhes.quantidadePartesAutoras);
        }

        return 0;
    }

    render() {
        return (
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    margin: '0px 2px',
                    alignItems: 'center',
                    width: '100%',
                    justifyContent: 'space-between'
                }}
            >
                {!this.isPreSessao && (
                    <Typography style={{ color: '#01579b', fontWeight: 'bold', fontSize: '0.95rem' }}>
                        Quant. partes autoras:{' '}
                        <span
                            style={{
                                color: this.qtdPartesAutoras !== 1 ? red[900] : '#01579b'
                            }}
                        >
                            {this.qtdPartesAutoras}
                        </span>
                    </Typography>
                )}
                <BloqueioBaixa registro={this.registro} />
                {!this.salaSessaoStore.isProcessoPje(this.registro) && (
                    <Transcendencia registro={this.registro} />
                )}
                <PresidenteSignatario registro={this.registro} />
                <span style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                    <PublicacaoAcordao registro={this.registro} />
                </span>
            </div>
        );
    }
}

export default inject('stores')(observer(RodapePainelDecisao));
